import { Injectable } from '@angular/core';
import * as fromPcs from '@app/pcs/reducer';
import { ValdrConstraintsRestService } from '@app/pcs/services/valdr-constraints-rest.service';
import { AddValdrConstraints } from '@app/valdr';
import { select, Store } from '@ngrx/store';
import { isNil } from 'ramda';
import { iif, Observable, of } from 'rxjs';
import { mergeMap, switchMap, tap } from 'rxjs/operators';

@Injectable()
export class ValdrConstraintsGuard  {

  constructor(private store: Store<fromPcs.State>,
    private valdrConstraintsRestService: ValdrConstraintsRestService) {
  }

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(fromPcs.getValdrConstraints),
      mergeMap((constants) =>
        iif(
          () => (isNil(constants)),
          this.valdrConstraintsRestService.fetchValdrConstraints().pipe(
            tap((constraints: any) => this.store.dispatch(new AddValdrConstraints(constraints))),
            switchMap(() => of(true))
          ),
          of(true)
        )
      )
    );
  }
}
